exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-pc[data-v-6ec993ba] {\n  height: auto !important;\n  width: 100% !important;\n  margin: auto;\n}\n.page-pc .page-pc-child[data-v-6ec993ba] {\n  overflow: hidden;\n  min-width: 13.66rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/loaders/stylePostLoader.js!./~/postcss-loader/src?{"path":"/Users/admin/Documents/futu-code/postcss.config.js"}!./~/less-loader!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=style&index=0&id=6ec993ba&lang=less&scoped=true&
// module id = 14
// module chunks = 1